import requestModule from '@/application/libs/requestModule'
import util from '@/application/libs/util'
import moment from 'moment'

export default {
    getJsonDataOfSelectedScenary(nrcenario) {
        return requestModule.postRequest('getData', {
            FROM: "JSONDATAOFSELECTEDSCENARY",
            PARAMS: {
                NRCENARIOCARD: nrcenario
            }
        });
    },
    
    checkFreezability(formData) {
        const { CDFILIAL, CDSERVFILI, DTMESCARD } = util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "PERMITECONGELAR",
            PARAMS: { CDFILIAL, CDSERVFILI, DTMESCARD }
        });
    },
    
    searchCostType(search, loading, component){
        loading(true);
        return requestModule.postRequest('getData', {
            FROM: "TIPOCUSTO_SEARCH",
            PARAMS: {
                CDFILIAL: util.getFilterInSession().CDFILIAL,
                NMTIPOCUSTO: search
            }
        }).then(response=>{
            let data = response.dataset && response.dataset.data;
            component.formData.costTypeOptions = data;
            loading(false);
        })
    },

    searchGroupProdLimit(loading, component){
        loading(true);
        return requestModule.postRequest('getData', {
            FROM: "GET_CDGRUPPROD",
            PARAMS: {}
        }).then(response=>{
            let data = response.dataset && response.dataset.data;
            component.formData.groupProdLimitOptions = data;
            loading(false);
        })
    },

    searchLinkCommonDishes(loading, component){
        loading(true);
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI, DTMESCARD
        } = util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "GET_LINK_COMMON_DISHES",
            PARAMS: { CDFILIAL, CDSERVFILI, DTMESCARD, IDTIPORESTRICAO }
        }).then(response=>{
            let data = response.dataset && response.dataset.data;
            component.formData.linkCommonDishesOptions = data;
            loading(false);
        })
    },
    
    searchUnits(loading, component){
        loading(true);
        
        const {CDOPERADOR} = JSON.parse(localStorage.getItem('userData'));
        
        return requestModule.postRequest('getData', {
            FROM: "FILIAL",
            PARAMS: {CDOPERADOR}
        }).then(response => {
            let data = response.dataset && response.dataset.data;
            component.formData.calcUnitCostOptions = data;
            loading(false);
        });
    },

    getGroupProdCard(){
        return requestModule.postRequest('getData', {
            FROM: "GET_CDGRUPPROD_PARAMGERAL",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },

    updateGrupProdCard(component) {
        return requestModule.postRequest('updateData', {
            FROM: "UPDATE_CDGRUPPROD_PARAMGERAL",
            PARAMS: {
                CDGRUPPROD: (component.formData.groupProdLimit !== null) ? 
                    component.formData.groupProdLimit.CDGRUPPROD : 
                    null
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getDefaultData(component){
        const { CDFILIAL, CDSERVFILI, DTMESCARD } = util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "DEFAULTOPTDATA",
            PARAMS: { CDFILIAL, CDSERVFILI, DTREFCUSPADR: DTMESCARD }
        }).then(response=>{
            let data = response.dataset && response.dataset.data[0];
            
            component.formData.calcUnitCost = null;
            component.formData.PERC_CUSTO_MAX = data? data.PERC_CUSTO_MAX: null;
            component.formData.PERC_CUSTO_MIN = data? data.PERC_CUSTO_MIN: null;
            component.formData.VLR_CUSTO_MIN = data? data.VLR_CUSTO_MIN: null;
            component.formData.VRCUSTPADR = data? data.VRCUSTPADR: null;
            component.formData.VLR_CUSTO_MAX = data? data.VLR_CUSTO_MAX: null;
            component.formData.DTREFECUSTO = data && data.DTREFECUSTO ? moment(data.DTREFECUSTO, 'DD/MM/YYYY').format('YYYY-MM-DD'): null;
            component.formData.P_DIA_SEMANA = moment(util.getFilterInSession().DTMESCARD, 'DD/MM/YYYY').weekday();
        })
    }
}